export default __webpack_public_path__ + "static/media/linear-systems.3efffdac.svg";